import React, { useState } from 'react';
import { Outlet } from 'react-router';
import { Grid } from '@abyss/web/ui/Grid';
import { Divider } from '@abyss/web/ui/Divider';
import { Loader } from '@src/components/global/Loader';
import { AlertComponent } from '@src/components/global/AlertComponent/AlertComponent';
import { ModalComponent } from '@src/components/global/ModalComponent/ModalComponent';
import { Footer } from './Footer';
import { LeftMenu } from './LeftMenu';
import { Header } from './Header';
import { Breadcrumb } from './Breadcrumb';
import { PageTitle } from './PageTitle';
import { MainContainer, FooterContainer } from './styles';
import { GlobalStyles } from '../styles';
import { isLeftMenuEnabled } from '@src/config/BoilerplateConfig';
import { ToastProvider } from '@abyss/web/ui/Toast';
import styles from './Layout.module.scss';

export const Layout = () => {
  GlobalStyles();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const leftMenuEnabled = isLeftMenuEnabled();

  const Action = {
    OnMobileMenuClick: () => {
      // Only handle menu toggle if left menu is enabled
      if (!leftMenuEnabled) return;

      setIsMenuOpen(!isMenuOpen);

      const menu = document.querySelector(
        '.menu-large-screen, .menu-large-screen-open'
      );
      if (menu) {
        if (isMenuOpen) {
          menu.classList.add('menu-large-screen');
          menu.classList.remove('menu-large-screen-open');
        } else {
          menu.classList.add('menu-large-screen-open');
          menu.classList.remove('menu-large-screen');
        }
      }

      const mainBlock = document.querySelector(
        '.main-content-large-screen, .main-content-large-screen-open'
      );
      if (mainBlock) {
        if (isMenuOpen) {
          mainBlock.classList.add('main-content-large-screen');
          mainBlock.classList.remove('main-content-large-screen-open');
        } else {
          mainBlock.classList.add('main-content-large-screen-open');
          mainBlock.classList.remove('main-content-large-screen');
        }
      }
    },
  };

  // Dynamic class names based on left menu configuration
  const getMainContentClass = () => {
    if (!leftMenuEnabled) {
      return 'main-content-full-width';
    }
    return 'main-content-large-screen';
  };

  const getMainBlockClass = () => {
    if (!leftMenuEnabled) {
      return styles.mainBlockFullWidth;
    }
    return styles.mainBlock;
  };

  return (
    <React.Fragment>
      <Header
        onMobileMenuClick={
          leftMenuEnabled ? Action.OnMobileMenuClick : undefined
        }
      />
      <div className="main-container">
        <ToastProvider />
        <Loader>
          <MainContainer css={leftMenuEnabled ? {} : { marginLeft: '0' }}>
            {/* Conditionally render left menu */}
            {leftMenuEnabled && (
              <div className="menu-large-screen">
                <div className={styles.sidebarParentContainer}>
                  <div className={styles.sidebarContainer}>
                    <LeftMenu />
                  </div>
                </div>
              </div>
            )}
            <div className={getMainContentClass()}>
              <div className={getMainBlockClass()}>
                <Grid>
                  <Grid.Col
                    span={12}
                    css={{
                      marginTop: 2,
                      paddingLeft: '2rem',
                      paddingRight: '2rem',
                    }}
                  >
                    <Breadcrumb />
                  </Grid.Col>
                  <Grid.Col
                    span={12}
                    css={{ paddingLeft: '2rem', paddingRight: '2rem' }}
                  >
                    <PageTitle />
                  </Grid.Col>
                  <Divider height={1} />
                </Grid>
                <Grid>
                  <Grid.Col
                    span={12}
                    css={{ paddingLeft: '1rem', paddingRight: '1rem' }}
                  >
                    <AlertComponent />
                    <Outlet />
                  </Grid.Col>
                </Grid>
              </div>
            </div>
          </MainContainer>
          <FooterContainer css={leftMenuEnabled ? {} : { marginLeft: '0' }}>
            <Footer />
          </FooterContainer>
          <ModalComponent />
        </Loader>
      </div>
    </React.Fragment>
  );
};
